module.exports = __webpack_public_path__ + "202408221624/img/img_help_sence.401853b0.png";